import { EmptyState } from '@c42/component-library';
import { CheckCircle } from 'mdi-material-ui';
import React from 'react';
import Text from '../../shared/Text';
import CommonStaticLayout from './common-static-layout';

const SsoAuthLoginSuccessCp3: React.FC = () => {
  React.useEffect(() => {
    document.title = Text.get('sso_doc_title_success');
  }, []);

  return (
    <CommonStaticLayout noPadding>
      <EmptyState
        icon={<CheckCircle color="success" />}
        title={Text.get('ssoAuthSignIn_success_message1')}
        subtitle={Text.get('ssoAuthSignIn_success_message2')}
        PaperProps={{ elevation: 0 }}
      />
    </CommonStaticLayout>
  );
};

export default SsoAuthLoginSuccessCp3;
